import { render, staticRenderFns } from "./CourseStepDeleteDialog.vue?vue&type=template&id=7ede5f15"
import script from "./CourseStepDeleteDialog.vue?vue&type=script&lang=js"
export * from "./CourseStepDeleteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports